import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { Delimiter, NOT_AVAILABLE } from '../../../common/constants';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { DirectivesModule } from '../../../common/directives/directives.module';
import { InfoFieldItemComponent } from '../info-field-item/info-field-item.component';

@Component({
  selector: 'ui-info-field-item-value-list',
  imports: [
    CommonModule,
    MatFormFieldModule,
    TranslateModule,
    PipesModule,
    DirectivesModule,
    InfoFieldItemComponent,
  ],
  templateUrl: './info-field-item-value-list.component.html',
  styleUrls: ['./info-field-item-value-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class InfoFieldItemValueListComponent {
  @Input() label: string;
  @Input() items: string[];

  delimiter = Delimiter;
  notAvailable = NOT_AVAILABLE;
}
